export interface IToastNotification {
  id: number;
  message: string;
  type: 'info' | 'error';
  duration: number;
}

interface IAddNotificationOptions {
  message: IToastNotification['message'];
  type: IToastNotification['type'];
  duration?: number;
}

type IToastSubscriberFunc = (notifications: IToastNotification[]) => void;

let notifications: IToastNotification[] = [];
let subscribers: IToastSubscriberFunc[] = [];
let nextId: number = 1;

const dispatch = () => {
  subscribers.forEach((subscriber: IToastSubscriberFunc) => subscriber(notifications));
};

export const subscribe = (subscriber: IToastSubscriberFunc) => {
  let isSubscribed = true;
  subscribers.push(subscriber);
  return () => {
    if (!isSubscribed) {
      return;
    }
    isSubscribed = false;
    subscribers = subscribers.filter((func) => func !== subscriber);
  };
};

export const remove = (id: number): void => {
  const next = notifications.filter((notification) => notification.id !== id);
  if (next.length === notifications.length) {
    return;
  }

  notifications = next;
  dispatch();
};

export const add = (options: IAddNotificationOptions): void => {
  const notification: IToastNotification = {
    ...options,
    duration: options.duration || 5000,
    id: ++nextId
  };
  notifications = [...notifications, notification];

  setTimeout(() => remove(notification.id), notification.duration);
  dispatch();
};

export const clear = (): void => {
  notifications = [];
  dispatch();
};



// WEBPACK FOOTER //
// ./src/components/Toast/store.ts